import React from "react";
import { pluralize } from "@common/helpers/string";

interface Props {
    filters: {
        coaAccounts?: string[];
    };
}

export const CoaAccountFilterLabel: React.FC<Props> = ({
    filters: { coaAccounts },
}) => {
    if (coaAccounts) {
        return (
            <>
                {coaAccounts.length}{" "}
                {pluralize("Account", coaAccounts?.length ?? 0)}
            </>
        );
    }
};
